export enum OperacionControlOperativoFields {
  CodPais = 'codPais',
  CodOperacionControlOperativoEstado = 'codOperacionControlOperativoEstado',
  FechaCarga = 'fechaCarga',
  Responsable = 'responsable',
  Observaciones = 'observaciones',
  FechaAlta = 'fechaAlta',
  IdUsuarioAlta = 'idUsuarioAlta',
  FechaUltMod = 'fechaUltMod',
  IdUsuarioUltMod = 'idUsuarioUltMod',
  NombreUsuarioAlta = 'nombreUsuarioAlta',
  ApellidoUsuarioAlta = 'apellidoUsuarioAlta',
  MailUsuarioAlta = 'mailUsuarioAlta',
  EstadoFinalizado = 'estadoFinalizado',
  Envio = 'envio',
  IdMensaje = 'idMensaje',
  PermiteEditarOperacion = 'permiteEditarOperacion',
  PermiteEliminarOperacion = 'permiteEliminarOperacion',
  Detalle = 'detalle',
}

export enum OperacionControlOperativoDetalleFields {
  IdOperacionControlOperativo = 'idOperacionControlOperativo',
  Sociedad = 'sociedad',
  Control = 'control',
  Descripcion = 'descripcion',
  Conclusion = 'conclusion',
  FechaAlta = 'fechaAlta',
  IdUsuarioAlta = 'idUsuarioAlta',
  FechaUltMod = 'fechaUltMod',
  IdUsuarioUltMod = 'idUsuarioUltMod',
  Activo = 'activo',
  PermiteEditar = 'permiteEditar',
}